import { infer as Infer, z } from 'zod';

export const postPublicationTimestampSchema = z.object({
  date: z.iso.datetime({ message: 'Data jest wymagana' }),
  time: z.iso.time().nullable(),
});

export type PostPublicationTimestampSchema = Infer<typeof postPublicationTimestampSchema>;
